import { FC } from 'react';
import styled from 'styled-components';

import { Controls, ControlsButton } from '@/components/Controls';

const StyledControls = styled(Controls)`
  display: flex;
  margin-top: 8px;
`;

const StyledControlsButton = styled(ControlsButton)`
  flex: 1;
  justify-content: center;
`;

interface Props {
  isChannelGroups: boolean;
  setIsChannelGroups: React.Dispatch<React.SetStateAction<boolean>>;
}

const FormChannelGroupSwitch: FC<Props> = ({
  isChannelGroups,
  setIsChannelGroups,
}) => {
  return (
    <StyledControls>
      <StyledControlsButton
        type="button"
        gray
        blackText
        active={!isChannelGroups}
        onClick={() => setIsChannelGroups(false)}
      >
        Channel
      </StyledControlsButton>
      <StyledControlsButton
        type="button"
        gray
        blackText
        active={isChannelGroups}
        onClick={() => setIsChannelGroups(true)}
      >
        Group
      </StyledControlsButton>
    </StyledControls>
  );
};

export default FormChannelGroupSwitch;
